//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable object-curly-newline */
/* eslint-disable operator-linebreak */
/* eslint-disable arrow-body-style */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-param-reassign */
import { ref, computed, watch } from '@vue/composition-api'
import { mdiPlus, mdiDeleteOutline, mdiClose, mdiMenuDown } from '@mdi/js'
import { required, integerValidator, emailValidator } from '@core/utils/validation'
import { useUtils } from '@core/libs/i18n'
import useCryptoJs from '@core/utils/useCryptoJs'

export default {
  name: 'Report',
  model: {
    prop: 'isModalOpen',
    event: 'update:is-modal-open',
  },
  props: {
    isModalOpen: {
      type: Boolean,
      required: true,
    },
    minPlayers: {
      type: Number,
      default: 12,
      required: false,
    },
  },
  setup(props, { emit }) {
    const { t } = useUtils()
    const { userData } = useCryptoJs()
    const form = ref(null)
    const issue = ref(null)
    const email = ref(null)

    const computedIsModalOpen = computed(() => props.isModalOpen)
    const computedMinPlayers = computed(() => props.minPlayers)

    const validateMinPlayer = v => {
      if (v >= computedMinPlayers.value) return true

      return `Número de jugadores debe ser mayor o igual a ${computedMinPlayers.value}`
    }

    const onSave = () => {
      if (form.value.validate()) emit('report-issue', issue.value, email.value)
    }

    watch([computedIsModalOpen], () => {
      if (!computedIsModalOpen.value) {
        issue.value = null
        email.value = null
        form.value.resetValidation()
      }
    })

    return {
      // data
      userData,
      form,
      issue,
      email,

      // computed
      computedIsModalOpen,
      computedMinPlayers,

      // methods
      onSave,

      // validations
      required,
      integerValidator,
      validateMinPlayer,
      emailValidator,

      // i18n
      t,

      // icons
      icons: {
        mdiPlus,
        mdiDeleteOutline,
        mdiClose,
        mdiMenuDown,
      },
    }
  },
}
